import PropTypes from 'prop-types';
export const ProgressBarDefaultProps = {
    progress: 0,
    disabled: false,
    showPercentage: true
};
export const ProgressBarPropTypes = {
    progress: PropTypes.number,
    width: PropTypes.string,
    disabled: PropTypes.bool,
    showPercentage: PropTypes.bool
};
//# sourceMappingURL=ProgressBar.prop-types.js.map